export enum EnumNivelCicloFacturacion {
  Contrato = 1,
  Trade,
  Producto
}
